var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1 1 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.4 8.82c.179.153.179.407.026.584-.127.178-.38.178-.558.026l-.94-.838v5.002a2.02 2.02 0 0 1-2.031 2.031H5.584a2.005 2.005 0 0 1-2.03-2.031V8.592l-.966.838c-.177.152-.431.152-.558-.026-.153-.177-.153-.431.025-.584l6.906-6.068a.37.37 0 0 1 .534 0zM5.585 14.813H7.21V10.75c0-.432.356-.812.813-.812h2.438c.431 0 .812.38.812.812v4.063h1.625c.66 0 1.219-.534 1.219-1.22V7.882L9.24 3.59 4.366 7.88v5.714c0 .685.533 1.219 1.218 1.219m2.438 0h2.438V10.75H8.022z"
  })));
};
export default SvgHome;